import Feature from 'Services/Feature';

const TimelineCardMixin = {
    props: {
        oneLog: { type: Object, required: true },
        linkedid: { type: Number, required: true },
        linkedtype: { type: String, required: true },
        isPinnable: { type: Boolean, default: true },
    },
    data() {
        return {
            intervalCallidES: null,
        };
    },
    beforeUnmount() {
        this.unsetIntervalCallidES();
    },
    methods: {
        unsetIntervalCallidES() {
            clearInterval(this.intervalCallidES);
            this.intervalCallidES = null;
        },

        /**
         * If card doesn't own a idES value, then try to get it through api call (look at getCardIdES) every second
         * with the max being 13, count with the fibonacci method.
         * If idES exists, then can call other function to pin/unpin. Else call a toast and kill the setInterval
         * @param {boolean} isPinned : if true call an unpin action else call a pin action
         * @param {object} relatedData : contains the userForename and useName
         */
        togglePin(isPinned, relatedData) {
            let timer = 0;
            let nextTimer = 1;
            let maxTimer = 0;
            let idES = '';
            if (!this.oneLog.idES) {
                const _this = this;
                this.intervalCallidES = setInterval(() => {
                    if (maxTimer >= 13 || idES.length > 0) {
                        _this.atIntervalCallidESEnd(isPinned, relatedData, idES);
                    } else {
                        _this.getCardIdES().then((response) => (idES = response));

                        // fibonacci algo
                        maxTimer = timer + nextTimer;
                        timer = nextTimer;
                        nextTimer = maxTimer;
                    }
                }, 1000);
            } else {
                isPinned
                    ? this.unpinCard(this.oneLog.idES)
                    : this.pinCard(relatedData, this.oneLog.idES);
            }
        },
        atIntervalCallidESEnd(isPinned, relatedData, idES) {
            if (idES?.length === 0) {
                const msg = isPinned
                    ? this.$l10n.__(
                        "L'élément n'a pas pu être désépinglé. Actualisez la page et réessayez.",
                    )
                    : this.$l10n.__(
                        "L'élément n'a pas pu être épinglé. Actualisez la page et réessayez.",
                    );

                this.$pushToast({
                    type: 'error',
                    icon: true,
                    text: msg,
                    timeout: 7000,
                    action: {
                        text: this.$l10n.__('Actualiser'),
                        callback: () => {
                            location.reload();
                        },
                    },
                    close: true,
                });
                this.unsetIntervalCallidES();
            } else {
                isPinned ? this.unpinCard(idES) : this.pinCard(relatedData, idES);
            }
        },

        pinCard(relatedData, idES) {
            ApiClient.post(
                `timeline/${this.getCardType}/${this.linkedid}/activities/${idES}/pin`,
                {},
                {},
            ).then(() => {
                const pin = {
                    staff_first_name: relatedData.userForename,
                    staff_last_name: relatedData.userName,
                };
                EventBus.emit('timeline:toggle-pin', { ...this.oneLog, pin });
                window.EventBus.emit('timeline:refreshCounter', {
                    label: 'pinned',
                    addedValue: 1,
                });
                this.unsetIntervalCallidES();
            });
        },

        unpinCard(idES) {
            ApiClient.del(
                `timeline/${this.getCardType}/${this.linkedid}/activities/${idES}/pin`,
                {},
                {},
            ).then(() => {
                const pin = null;
                EventBus.emit('timeline:toggle-pin', { ...this.oneLog, pin });
                window.EventBus.emit('timeline:refreshCounter', {
                    label: 'pinned',
                    addedValue: -1,
                    objectid: this.oneLog.objectid,
                });
                this.unsetIntervalCallidES();
            });
        },
        async getCardIdES() {
            return await new Promise((resolve, reject) => {
                window.SellsyJS.WebServiceCaller.get(
                    `/timeline/last/${this.linkedtype}/${this.linkedid}/${this.oneLog.objecttype}/${this.oneLog.objectid}`,
                    {},
                    (response) => {
                        const idES = response.past
                            ? response.past[0].idES
                            : response.incoming[0].idES;
                        resolve(idES);
                    },
                    () => {
                        reject();
                    },
                );
            });
        },
    },
    computed: {
        getCardType() {
            let type = this.linkedtype;
            switch (this.linkedtype) {
                case 'client':
                case 'supplier':
                case 'prospect':
                    type = 'company';
                    break;
                case 'people':
                    type = 'contact';
                    break;
            }

            if (this.isParticular) type = 'individual';
            return type;
        },
        isThird() {
            return ['client', 'prospect', 'supplier'].includes(this.$store.getters.identity?.type);
        },
        hasPersonTag() {
            return this.isThird && !this.$store.getters.identity.isCorporation;
        },
        isParticular() {
            return this.isThird && this.hasPersonTag;
        },
        /**
         * Only allowed if feature flag
         * @returns boolean
         */
        canTogglePin() {
            return Feature.isEnabled('timeline-activity-pinning') && this.isPinnable;
        },
        pinStatusLabel() {
            return !this.isPinned ? this.$l10n.__('Épingler') : this.$l10n.__('Désépingler');
        },
        isPinned() {
            return !!this.oneLog.pin ?? false;
        },
        canSeeDropdown() {
            return (
                this.oneLog.can_edit ||
                this.oneLog.canSee ||
                this.oneLog.can_delete ||
                this.canTogglePin
            );
        },
    },
};

export default TimelineCardMixin;
